import styles from './index.module.sass';
import { PageTemplate } from '../../components/page-template';
import { BuyerOffers } from '../../components/buyer-offers';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const BuyerAccountPage = () => {
    const [params] = useSearchParams();
    // const [] = useState();
    useEffect(() => {
        const user_type = params.get('user_type');
        if (user_type === 'buyer') {

        }
    }, []);
    const navItems = [
        { label: 'предложения', to: '/', active: true },
        { label: 'пункты приема', to: '/buyer-points', active: false },
    ];
    return (
        <PageTemplate navItems={navItems}>
            <BuyerOffers/>
        </PageTemplate>
    )
}